import qs from 'querystring';

export const getQueryParams = () => {
    // Need to be extra careful because with embedded navigation window is undefined for some reason.
    if (!window || !window.location || !window.location.search) {
        return {};
    }
    const search = window.location.search.substring(1); // remove ? from the search component
    const params = qs.parse(search);

    // Match i18next's querystring detector, which lets the last locale win.
    if (Array.isArray(params.locale)) {
        params.locale = params.locale[params.locale.length - 1];
    }

    return params;
};
